import React from "react";
import { FiArrowUpRight } from "react-icons/fi";

/**
 * What you see before the first question.
 *
 * The hero used to sit permanently above the chat — badge, gradient headline,
 * and six suggestion cards that stayed on screen mid-conversation and pushed
 * the answers below the fold. It belongs in the empty state only, and it
 * disappears the moment there is a transcript to read.
 */
export default function EmptyState({ prompts = [], onPromptSelect, disabled }) {
  return (
    <div className="flex h-full flex-col items-center justify-center px-4 py-10">
      <div className="w-full max-w-2xl text-center">
        <h1 className="font-raleway text-[30px] leading-tight tracking-[-0.02em] text-iq-ink sm:text-[34px]">
          <span className="font-light">Ask me about </span>
          <span className="font-semibold text-iq-brand">payments</span>
          <span className="font-light"> &amp; </span>
          <span className="font-semibold text-iq-brand">connectivity</span>
        </h1>
        <p className="mt-3 text-[14.5px] text-iq-ink-soft">
          Answers are scoped to the market you pick below the composer.
        </p>

        {prompts.length > 0 && (
          <div className="mt-8 grid grid-cols-1 gap-2 text-left sm:grid-cols-2">
            {prompts.map((prompt) => (
              <button
                key={prompt}
                type="button"
                disabled={disabled}
                onClick={() => onPromptSelect?.(prompt)}
                className="group flex items-start justify-between gap-3 rounded-xl border border-iq-line bg-white px-3.5 py-3 text-[13.5px] leading-snug text-iq-ink-soft transition-colors hover:border-iq-brand/40 hover:bg-iq-brand-soft hover:text-iq-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-iq-brand disabled:opacity-50"
              >
                <span>{prompt}</span>
                <FiArrowUpRight className="mt-0.5 h-3.5 w-3.5 shrink-0 text-iq-ink-faint transition-colors group-hover:text-iq-brand" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
